g
<template>
  <section class="promo-wrapper content-w">
    <img src="@/assets/kv-age.png" class="kv-age" />

    <div class="promo-img">
      <div>
        <picture>
          <source
            srcset="@/assets/kv-text@mobile.png"
            type="image/png"
            media="(max-width: 678px)"
          />
          <img
            src="@/assets/svg/kv-text@desktop.svg"
            class="kv-title"
            alt="Выиграй призы для дачи"
          />
        </picture>

        <img src="@/assets/kv-win@desktop.png" class="kv-text" />

        <img src="@/assets/steam.gif" class="kv-steam" loading="lazy" />

        <picture>
          <source
            srcset="@/assets/kv-img@mobile.png"
            type="image/png"
            media="(max-width: 678px)"
          />
          <source
            srcset="@/assets/kv-img@laptop.png"
            type="image/png"
            media="(max-width: 1024px) and (min-width: 678px)"
          />
          <img
            src="@/assets/kv-img@desktop.png"
            class="kv-img"
            alt="Продукция"
          />
        </picture>

<!--        <b-button-->
<!--          class="promo-button button button-gold"-->
<!--          v-if="!user"-->
<!--          v-b-modal.login-modal-->
<!--          variant="primary"-->
<!--          onclick="ym(108239013,'reachGoal', 'cod_1')"-->
<!--        >-->
<!--          <span class="desktop">Регистрация кода</span>-->

<!--          <span class="mobile">Участвовать</span>-->
<!--        </b-button>-->

        <b-button
          class="promo-button button button-gold"
          variant="primary"
          @click="openModal()"
        >
<!--          <span class="desktop">Регистрация кода</span>-->

          <span>Введите код</span>
        </b-button>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "PromoSection",

  data: () => ({}),

  computed: {
    ...mapGetters({
      user: "user",
    }),
  },

  methods: {
    openModal() {
      console.log(this.user)
      ym(108239013,'reachGoal', 'cod_1')
      this.$bvModal.show('promo-end-modal')
      // if(this.user){
      //   this.$bvModal.show('enter-code-modal')
      // } else {
      //   this.$bvModal.show('login-modal')
      // }
    },
  },
};
</script>

<style scoped lang="scss">
.promo-wrapper {
  background-image: url("@/assets/kv-bg.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: bottom center;
  width: 100%;
  height: 100%;
  border-radius: 20px;
  display: flex;
  background-color: $green;
  height: 100%;
  justify-content: center;
  position: relative;
  overflow: hidden;
}

.kv-img {
  width: auto;
  max-width: 100%;
  margin-right: -12%;
  z-index: 99;
  position: relative;

  @media (max-width: 1500px) {
    max-width: 96%;
  }

  @media (max-height: 760px) and (min-width: 1200px) {
    max-width: 86%;
  }

  @media (max-width: 1100px) and (min-height: 610px) {
    max-width: 77%;
    margin-left: 14.5%;
  }

  @media (max-width: 1100px) and (max-height: 610px) {
    max-width: 78%;
    margin-left: 0%;
  }

  @media (max-width: 678px) {
    width: 100%;
    margin: 0 !important;
    max-width: none;
  }

  //&__desktop {
  //  @media (max-width: 1025px) {
  //    display: none;
  //  }
  //}
  //
  //&__laptop {
  //  display: none;
  //
  //  @media (max-width: 1025px) {
  //    display: flex;
  //  }
  //
  //  @media (max-width: 678px) {
  //    display: none;
  //  }
  //}
  //
  //&__mobile {
  //  display: none;
  //
  //  @media (max-width: 678px) {
  //    display: flex;
  //  }
  //}
}

.kv-title {
  position: absolute;
  top: 28%;
  left: 0;
  max-width: 510px;
  z-index: 98;

  @media (max-width: 1200px) {
    max-width: 450px;
    left: 20px;
  }

  @media (max-width: 1100px) {
    max-width: 340px;
    left: 73px;
    top: 40%;
  }

  @media (max-width: 678px) {
    max-width: 249px;
    top: 155px;
    left: 50%;
    right: 50%;
    transform: translate(-50%, -50%);
  }
}

.kv-age {
  position: absolute;
  bottom: 22px;
  left: 12px;
  width: 100%;
  z-index: 2;
  max-width: 125px;

  @media (max-width: 1200px) {
    max-width: 92px;
    bottom: 17px;
    left: 8px;
  }

  @media (max-width: 768px) {
    max-width: 45px;
  }

  @media (max-width: 678px) {
    max-width: 45px;
    bottom: 7px;
    left: 4px;
  }
}

.kv-text {
  position: absolute;
  top: 25%;
  right: 0;
  width: 100%;
  max-width: 320px;
  z-index: 98;

  @media (max-width: 1200px) {
    max-width: 280px;
    right: 20px;
  }

  @media (max-width: 1100px) {
    max-width: 180px;
    left: 73px;
    top: 22%;
  }

  @media (max-width: 678px) {
    max-width: 112px;
    margin-top: 49%;
    left: 5.5%;
  }
}

.kv-steam {
  position: absolute;
  right: 0;
  top: 34%;
  filter: blur(10px) contrast(90%);

  @media (max-width: 678px) {
    width: 100%;
    bottom: 12%;
    right: -56%;
    top: auto;
  }
}

.promo-img {
  display: flex;
  position: relative;
  height: calc(100vh - 80px);
  justify-content: flex-end;
  align-items: flex-end;
  width: 100%;
  max-width: 1128px;
  padding-left: 15px;
  padding-right: 15px;
  border-radius: 20px;

  @media (max-width: 1200px) {
  }

  @media (max-width: 678px) {
    padding-left: 0;
    padding-right: 0;
    height: calc(100vh - 130px);
  }
}

.promo-button {
  position: fixed;
  bottom: 0;
  height: 65px;
  display: flex;
  font-weight: 600;
  font-size: 20px;
  align-items: center;
  justify-content: center;
  font-family: $regular;
  width: 100%;
  max-width: 357px;
  transition: 0.8s all !important;
  z-index: 999999;
  margin-left: auto;
  margin-right: auto;
  left: 50%;
  right: 50%;
  margin-bottom: -25px;
  transform: translate(-50%, -50%);

  @media (max-width: 1200px) {
    height: 47px;
    margin-bottom: -10px;
    font-size: 18px !important;
  }

  @media (max-width: 678px) {
    max-width: 190px;
    top: calc(100vh - 110px);
    font-size: 14px !important;
  }
}

.desktop {
  @media (max-width: 1025px) {
    display: none;
  }
}

.mobile {
  display: none;

  @media (max-width: 1025px) {
    display: block;
  }
}
</style>
